export const sendto: any[] = [
    {label: "Grupos de Usuários", value: "1"},
    {label: "Grupos de Não Usuários", value: "3"},
    {label: "Importação", value: "2"},
]